<template>
  <div class="video-wrapper" ref="videoPlayer">
    <div class="video-container">
      <video ref="videoMedia" playsinline width="100%" height="100%">
        <source :src="url" />
      </video>
    </div>
    <div class="player-container">
      <div class="play-control">
        <div
          class="play-button icon-video-play"
          :class="{ hide: videoPlaying }"
          v-on:click.prevent="playVideo"
        ></div>
        <div
          class="pause-button icon-video-pause"
          :class="{ hide: !videoPlaying }"
          v-on:click.prevent="pauseVideo"
        ></div>
      </div>
      <div class="timeline">
        <div class="progress-background icon-video-timeline">
          <div class="icon-video-scrubber"></div>
        </div>
      </div>
      <div class="volume-control">
        <div
          class="volume-button icon-video-audio-on"
          :class="{ hide: videoMuted }"
          v-on:click.prevent="muteAudio"
        ></div>
        <div
          class="volume-button-mute icon-video-audio-off"
          :class="{ hide: !videoMuted }"
          v-on:click.prevent="unmuteAudio"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import { TweenMax } from 'gsap';
import { mapMutations } from 'vuex';
import btnClose from 'assets/svg/btn-close.svg';

export default {
  props: {
    roundIndex: Number,
    url: String,
    onVideoEnd: {
      type: Function,
      default: () => () => {}
    }
  },
  data() {
    return {
      videoPlaying: false,
      videoMuted: false,
      videoDone: false,
      videoRef: '',
      scrubberX: '',
      videoMedia: null,
      videoPlayer: null,
      buttonClose: btnClose
    };
  },
  mounted() {
    this.videoRef = this.$refs.videoMedia;
    const promise = this.videoRef.play();
    if (promise !== undefined) {
      promise
        .then(() => {
          // Play started, update play button
          this.videoPlaying = true;
        })
        .catch(error => {
          // Autoplay was prevented.
          // Show a "Play" button so that user can start playback.
          this.videoPlaying = false;
        });
    }
    this.videoRef.addEventListener('timeupdate', this.videoTimeUpdated, false);
  },
  methods: {
    ...mapMutations('application', ['setModal']),
    closeModal() {
      this.pauseVideo();
      // this.$dispatch('closeModal');
      this.setModal(undefined);
    },
    pauseVideo() {
      this.videoPlaying = false;
      this.videoRef.pause();
    },
    playVideo() {
      this.videoPlaying = true;
      this.videoRef.play();
    },
    muteAudio() {
      this.videoMuted = true;
      this.videoRef.muted = true;
    },
    unmuteAudio() {
      this.videoMuted = false;
      this.videoRef.muted = false;
    },
    videoTimeUpdated() {
      this.videoEndCheck();
      this.scrubberX = Math.floor((this.videoRef.currentTime / this.videoRef.duration) * 600) - 16;
      TweenMax.set('.icon-video-scrubber', {
        css: { left: `${this.scrubberX}px` }
      });
    },
    videoEndCheck() {
      if (this.videoRef.currentTime >= this.videoRef.duration) {
        this.videoPlaying = false;
        this.videoDone = true;
        this.onVideoEnd('video', this.roundIndex, 'test');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.video-wrapper {
  width: 93%;

  .video-container {
    display: block;
  }

  video {
    margin: auto;
  }
}
</style>
